import { createStrictContext } from 'utils/createContext'
import { TargetsContext } from './types'
import {
  useEditLimsAsphaltMixDesignTargetMutation,
  useLimsAsphaltMixDesignTargetsMetadataQuery,
  useLimsAsphaltMixDesignTargetsQuery,
} from 'schema'
import {
  DefaultMutationHookOptions,
  DefaultQueryHookOptions,
} from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } =
  createStrictContext<TargetsContext>('TargetsContext')

export const useTargetsContext = useContextFn

const TargetsProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const { data, loading, refetch } = useLimsAsphaltMixDesignTargetsQuery({
    variables: { input: { projectId: { equals: projectId } } },
    ...DefaultQueryHookOptions,
  })
  const { data: metadataData, ...metadata } =
    useLimsAsphaltMixDesignTargetsMetadataQuery({
      variables: { projectId },
      ...DefaultQueryHookOptions,
    })
  const [edit] = useEditLimsAsphaltMixDesignTargetMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editLIMSAsphaltMixDesignTarget: {
        target: { name },
      },
    }) => simpleEditNotification(name),
  })
  return (
    <Provider
      value={{
        edit: async (input) => {
          await edit({ variables: { input } })
        },
        metadata: {
          ...metadata,
          mixDesigns: metadataData?.asphaltMixDesigns?.records ?? [],
        },
        loading,
        refetch,
        targets: data?.limsAsphaltMixDesignTargets?.records ?? [],
      }}
    >
      {children}
    </Provider>
  )
}

export default TargetsProvider
